<script>
import Business from '../index.vue';
export default {
  extends: Business,
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    },
    async initPageData() {}
  }
};
</script>
